/* =========================================
   ZIMA tee studio — Shopify Theme JS
   =========================================
   Note:
   - Tutto è delegato su document: funziona anche con contenuti
     iniettati dopo il load (cart drawer, quick view, theme editor).
   - init() è idempotente e viene rilanciato sugli eventi shopify:section:*
     così le sezioni ricaricate nell'editor tornano funzionanti.
   ========================================= */

(function () {
  'use strict';

  /* ---------- utils ---------- */

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.prototype.slice.call(root.querySelectorAll(sel));

  const safeSession = {
    get(key) {
      try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
    },
    set(key, value) {
      try { window.sessionStorage.setItem(key, value); } catch (e) { /* private mode */ }
    }
  };

  /* =========================================
     Mobile menu
     ========================================= */

  const MobileNav = {
    get nav() { return $('.mobile-nav'); },
    get btn() { return $('.header-mobile-menu'); },

    open() { this.set(true); },
    close() { this.set(false); },
    toggle() { this.set(!this.isOpen()); },

    isOpen() {
      const nav = this.nav;
      return !!nav && nav.classList.contains('is-open');
    },

    set(open) {
      const nav = this.nav;
      const btn = this.btn;
      if (!nav) return;

      nav.classList.toggle('is-open', open);
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');

      // blocca lo scroll del body mentre il menu è aperto
      document.documentElement.classList.toggle('nav-open', open);

      if (open) {
        const firstLink = nav.querySelector('a, button');
        if (firstLink) firstLink.focus();
      } else if (btn && nav.contains(document.activeElement)) {
        btn.focus();
      }
    }
  };

  /* =========================================
     Product gallery
     ========================================= */

  const Gallery = {
    selectThumb(thumb) {
      const gallery = thumb.closest('.product-gallery') || document;
      const mainImg = $('#gallery-main-img', gallery) || $('#gallery-main-img');
      if (!mainImg) return;

      const { fullSrc, fullSrcset, fullAlt, fullWidth, fullHeight } = thumb.dataset;

      if (fullSrc) mainImg.src = fullSrc;
      // srcset va sempre riallineato: se resta quello vecchio il browser
      // può continuare a servire l'immagine precedente.
      mainImg.srcset = fullSrcset || '';
      if (fullAlt) mainImg.alt = fullAlt;
      if (fullWidth) mainImg.width = fullWidth;
      if (fullHeight) mainImg.height = fullHeight;

      $$('.product-gallery__thumb', gallery).forEach((t) => {
        t.classList.toggle('active', t === thumb);
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    },

    // usata dal selettore varianti per allineare la thumb attiva
    selectByImageId(root, imageId) {
      if (!imageId) return;
      const thumb = $('.product-gallery__thumb[data-image-id="' + imageId + '"]', root);
      if (thumb) this.selectThumb(thumb);
    }
  };

  /* =========================================
     Variant selector
     -----------------------------------------
     QUI STAVA IL BUG: prima si aggiornava solo la classe .active,
     quindi l'input hidden name="id" restava sul valore iniziale
     (la prima variante disponibile → XS) e il carrello riceveva
     sempre quella.
     ========================================= */

  const variantCache = new WeakMap();

  const Variants = {
    getData(form) {
      if (variantCache.has(form)) return variantCache.get(form);

      const productId = form.dataset.productId;
      const scope = form.closest('.product-page') || document;
      const script =
        (productId && $('[data-variant-data-for="' + productId + '"]', scope)) ||
        $('[data-variant-data]', scope);

      let data = null;
      if (script) {
        try {
          data = JSON.parse(script.textContent).variants || null;
        } catch (e) {
          console.warn('[ZIMA] variant JSON non valido', e);
        }
      }

      variantCache.set(form, data);
      return data;
    },

    groups(form) {
      return $$('.variant-buttons', form).sort(
        (a, b) => Number(a.dataset.optionIndex || 0) - Number(b.dataset.optionIndex || 0)
      );
    },

    selection(form) {
      return this.groups(form).map((group) => {
        const active = $('.variant-btn.active', group);
        return active ? active.dataset.value : null;
      });
    },

    match(variants, selection) {
      return (
        variants.find((v) =>
          selection.every((val, i) => val !== null && v.options[i] === val)
        ) || null
      );
    },

    // Disattiva le combinazioni che non esistono o sono esaurite
    refreshAvailability(form, variants, selection) {
      this.groups(form).forEach((group, groupIndex) => {
        $$('.variant-btn', group).forEach((btn) => {
          const sellable = variants.some((v) => {
            if (v.options[groupIndex] !== btn.dataset.value) return false;
            const otherMatch = selection.every(
              (val, i) => i === groupIndex || val === null || v.options[i] === val
            );
            return otherMatch && v.available;
          });

          btn.classList.toggle('unavailable', !sellable);
          btn.setAttribute('data-available', sellable ? 'true' : 'false');
        });
      });
    },

    select(btn) {
      const group = btn.closest('.variant-buttons');
      const form = btn.closest('[data-product-form]');
      if (!group || !form) return;

      $$('.variant-btn', group).forEach((b) => {
        const isTarget = b === btn;
        b.classList.toggle('active', isTarget);
        b.setAttribute('aria-pressed', isTarget ? 'true' : 'false');
      });

      this.update(form);
    },

    update(form) {
      const variants = this.getData(form);
      if (!variants) return;

      const scope = form.closest('.product-page') || document;
      const idInput = $('[data-variant-id]', form);
      const submitBtn = $('[data-add-to-cart]', form);
      const submitText = $('[data-add-to-cart-text]', form) || submitBtn;
      const priceEl = $('[data-price]', scope);
      const compareEl = $('[data-compare-price]', scope);
      const priceWrapper = $('[data-price-wrapper]', scope);

      const selection = this.selection(form);
      const variant = this.match(variants, selection);

      this.refreshAvailability(form, variants, selection);

      // etichetta "Taglia: M"
      this.groups(form).forEach((group) => {
        const active = $('.variant-btn.active', group);
        const pos = group.dataset.optionPosition;
        const label = pos && $('[data-selected-for="' + pos + '"]', scope);
        if (label) label.textContent = active ? active.dataset.value : '';
      });

      if (!variant) {
        if (idInput) idInput.value = '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
        }
        if (submitText) submitText.textContent = 'Non disponibile';
        return;
      }

      // ⬅️ il punto chiave: l'ID inviato al carrello segue la selezione
      if (idInput) idInput.value = variant.id;

      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      }
      if (submitText) {
        submitText.textContent = variant.available ? 'Aggiungi al Carrello' : 'Esaurito';
      }

      if (priceEl) priceEl.innerHTML = variant.price;
      if (priceWrapper && variant.priceRaw) priceWrapper.setAttribute('content', variant.priceRaw);
      if (compareEl) {
        compareEl.innerHTML = variant.compareAtPrice || '';
        compareEl.hidden = !variant.compareAtPrice;
      }

      if (variant.imageId) Gallery.selectByImageId(scope, variant.imageId);

      if (window.history && window.history.replaceState) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* noop */ }
      }

      form.dispatchEvent(
        new CustomEvent('zima:variant:change', { bubbles: true, detail: { variant } })
      );
    },

    initForms(root = document) {
      $$('[data-product-form]', root).forEach((form) => {
        if (form.dataset.zimaVariantInit === 'true') return;
        form.dataset.zimaVariantInit = 'true';
        this.update(form);
      });
    }
  };

  /* =========================================
     Cart quantity +/-
     -----------------------------------------
     Prima si limitava a cambiare input.value: Shopify non se ne
     accorgeva mai. Ora emette change e, se il campo è dentro un
     form del carrello, lo invia.
     ========================================= */

  const CartQty = {
    step(button, delta) {
      const widget = button.closest('.cart-item__qty');
      const input = widget && widget.querySelector('input');
      if (!input) return;

      const min = input.min !== '' ? parseInt(input.min, 10) : 1;
      const max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
      const current = parseInt(input.value, 10);
      const base = Number.isNaN(current) ? min : current;

      const next = Math.min(max, Math.max(min, base + delta));
      if (next === current) return;

      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));

      const form = input.closest('form[action*="/cart"]');
      if (form && form.dataset.autoSubmit !== 'false') {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
    }
  };

  /* =========================================
     Newsletter
     -----------------------------------------
     Prima c'era un preventDefault() incondizionato: il form
     Shopify non veniva MAI inviato e nessuno si iscriveva.
     ========================================= */

  const Newsletter = {
    onSubmit(form) {
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.classList.add('is-loading');
        btn.disabled = true;
      }
      form.classList.add('is-submitting');
      // niente preventDefault: Shopify gestisce il POST a /contact
    }
  };

  /* =========================================
     Announcement bar
     ========================================= */

  const Announcement = {
    KEY: 'zima-announcement-dismissed',

    init(root = document) {
      const bar = $('.announcement-bar-section', root);
      if (!bar) return;
      if (safeSession.get(this.KEY)) bar.hidden = true;
    },

    dismiss(button) {
      const bar = button.closest('.announcement-bar-section') || $('.announcement-bar-section');
      if (!bar) return;
      bar.hidden = true;
      safeSession.set(this.KEY, '1');
    }
  };

  /* =========================================
     Event delegation
     ========================================= */

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    // mobile menu toggle
    const menuBtn = target.closest('.header-mobile-menu');
    if (menuBtn) {
      event.preventDefault();
      MobileNav.toggle();
      return;
    }

    if (target.closest('.mobile-nav-close')) {
      event.preventDefault();
      MobileNav.close();
      return;
    }

    // gallery
    const thumb = target.closest('.product-gallery__thumb');
    if (thumb) {
      event.preventDefault();
      Gallery.selectThumb(thumb);
      return;
    }

    // varianti
    const variantBtn = target.closest('.variant-btn');
    if (variantBtn) {
      event.preventDefault();
      Variants.select(variantBtn);
      return;
    }

    // quantità carrello
    const qtyBtn = target.closest('.cart-item__qty [data-action="minus"], .cart-item__qty [data-action="plus"]');
    if (qtyBtn) {
      event.preventDefault();
      CartQty.step(qtyBtn, qtyBtn.dataset.action === 'plus' ? 1 : -1);
      return;
    }

    // announcement bar
    const dismissBtn = target.closest('[data-dismiss="announcement"]');
    if (dismissBtn) {
      event.preventDefault();
      Announcement.dismiss(dismissBtn);
      return;
    }

    // click fuori dal menu mobile
    if (MobileNav.isOpen()) {
      const nav = MobileNav.nav;
      if (nav && !nav.contains(target)) MobileNav.close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && MobileNav.isOpen()) MobileNav.close();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('.newsletter-form')) {
      Newsletter.onSubmit(form);
      return;
    }

    // rete di sicurezza: ricalcola l'ID variante subito prima dell'invio
    if (form.matches('[data-product-form]')) {
      Variants.update(form);
      const idInput = $('[data-variant-id]', form);
      if (idInput && !idInput.value) {
        event.preventDefault();
        console.warn('[ZIMA] nessuna variante corrispondente alla selezione');
      }
    }
  });

  /* =========================================
     Init
     ========================================= */

  function init(root = document) {
    Variants.initForms(root);
    Announcement.init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Theme editor: le sezioni ricaricate devono reinizializzarsi
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => init(event.target));

  window.ZIMA = { MobileNav, Gallery, Variants, CartQty, init };
})();